import React from "react";
import { NavLink } from "react-router-dom";

function MenuInteremedioNiveles() {
  return (
    <nav className="levels-nav-strip" aria-label="Niveles educativos">
      <NavLink to="/nivelinicial" className="levels-nav-link">
        Nivel Inicial
      </NavLink>
      <NavLink to="/nivelprimario" className="levels-nav-link">
        Primario
      </NavLink>
      <NavLink to="/nivelsecundario" className="levels-nav-link">
        Secundario
      </NavLink>
      <NavLink to="/InglesIntensivo" className="levels-nav-link">
        Inglés
      </NavLink>
    </nav>
  );
}

export default MenuInteremedioNiveles;
